import React, { Component } from "react";
import MenuHome from "./components/MenuHome.js";
import "./style/styles.css";
import "./style/App.css"
import Content from "./shop/Content.js";
import CategoryList from "./shop/CategoryList.js";
import ConciseBasket from "./shop/ConciseBasket.js";
import Brands from "./shop/Brands.js";
import { LanguageProvider, Text } from './languages/Language.js';
import fetchDataFromAPI from "./fetch/useFetchDataFromAPI.js";
import useFetchCampaignPrice from "./fetch/useFetchCampaignPrice.js";
import useSendDataToAPI from "./shop/useSendDataToAPI.js";
import Toast from "./components/Toast.js";
import { TOAST_PROPERTIES } from './components/toastProperties.js';
import { URL as NEWURL } from './constants.js';
import { BRANDS as NEWBRANDS } from './constants.js';
import { VENDORID as NEWVENDORID } from './constants.js';
import ShowImpressum from "./pages/ShowImpressum.js";
import ShowDatenschutz from "./pages/ShowDatenschutz.js";
import ShowAGB from "./pages/ShowAGB.js";
import ShowContact from "./pages/ShowContact.js";
import ShowAboutUs from "./pages/ShowAboutUs.js";
import { createUpdateState } from './shop/updateStateUtils.js';
import MenuLogin from "./components/MenuLogin.js";
import CookieConsent from "./components/CookiePopup.js";
import AppFooter from "./components/AppFooter.js";
import { Helmet } from 'react-helmet';
import { companyName, CONFIG } from "./config.js";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import PaymentSuccess from "./payments/payment-success.js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { toast, ToastContainer } from "react-toastify";
import { getSettingJSONRequest } from "./fetch/getSettings.js";
import { secureKeyGet } from "./secretKey.js";
import LoadingOverlay from "./components/ProcessLoading.js";
import ShowDetailedBaskett from "./shop/ShowDetailedBasket.js";
import StripeSuccess from "./payments/stripe-success.js";
import RegisterModal from "./shop/RegisterModal.js";
import { updateItemAmountRequest } from "./fetch/updateItemAmount.js";


export const IMAGETIMESTAMP = (() => {
  const today = new Date();
  return `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
})();


export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      cartItems: [],
      items: [],
      allCategories: JSON.parse(sessionStorage.getItem('allCategories')),
      allFavorites: [],
      exist: "9",
      itemAmount: 1,
      sidebarOpen: false,
      productWebCategory: "Home",
      productWebSubCategory: "Deals",
      value: null,
      token: sessionStorage.getItem('token'),
      list: [],
      autoDeleteTime: 2000,
      autoDelete: true,
      categories: [],
      filteredData: [],
      impressum: false,
      datenschutz: false,
      agb: false,
      contact: false,
      aboutUs: false,
      detailedBasket: false,
      isCategoryOpen: false,
      isCartOpen: false,
      linearLoader: false,
      clickControl: false,
      clickedItemCode: "",
      sortingKey: 'itemSpeCode2',
      ascending: true,
      loadingOverlay: false,
      stripePromise: null,
    }
    this.idleTimeout = null;
    this.idleTime = 3600000; // 1 saat = 3600000 ms
    this.resetIdleTimer = this.resetIdleTimer.bind(this);
  }


  toggleLoadingOverlay = (state) => {
    this.setState({ loadingOverlay: state });
  }


  componentWillUnmount() {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach((event) => {
      window.removeEventListener(event, this.resetIdleTimer);
    });

    clearTimeout(this.idleTimeout);
  }

  startIdleTimer() {
    this.idleTimeout = setTimeout(() => {

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('paymentType');
      sessionStorage.removeItem('discRate');
      sessionStorage.removeItem('slipRef');
      sessionStorage.removeItem('items');
      sessionStorage.removeItem('allCategories');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('customerCode');
      sessionStorage.removeItem('Expl1');
      sessionStorage.removeItem('Expl2');

      this.onLogoutDeleteItemsAndCategories()
      window.location.reload();

    }, this.idleTime);
  }

  resetIdleTimer() {
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    this.startIdleTimer();
  }

  sortingFunc = (value) => {
    if (value == "alphabetical") {
      this.setState({ sortingKey: "itemName1" });
      this.setState({ ascending: true });
    }
    else if (value == "itemCode") {
      this.setState({ sortingKey: "itemCode" });
      this.setState({ ascending: true });
    }
    else if (value == "itemPriceA") {
      this.setState({ sortingKey: "itemPrice" });
      this.setState({ ascending: true });
    }
    else if (value == "itemPriceD") {
      this.setState({ sortingKey: "itemPrice" });
      this.setState({ ascending: false });
    }
    else if (value == "smart") {
      this.setState({ sortingKey: "itemSpeCode2" });
      this.setState({ ascending: true });
    }


  }

  toggleMenu = () => {

    this.setState((prevState) => ({ isCategoryOpen: !prevState.isCategoryOpen }));
  };

  toggleCart = () => {
    this.setState((prevState) => ({ isCategoryOpen: false }));
    this.setState((prevState) => ({ isCartOpen: !prevState.isCartOpen }));
  };

  ShowImpressum = value => {
    this.setState({ impressum: value })
  }
  ShowDatenschutz = value => {
    this.setState({ datenschutz: value })
  }
  ShowAGB = value => {
    this.setState({ agb: value })
  }
  ShowContact = value => {
    this.setState({ contact: value })
  }
  ShowAboutUs = value => {
    this.setState({ aboutUs: value })
  }
  ShowDetailedBasket = value => {
    this.setState({ detailedBasket: value })
  }

  showToast = type => {
    const toastProperties = TOAST_PROPERTIES.find((toast) => toast.title.toLowerCase() === type.toLowerCase());
    this.setState({ list: [...this.state.list, toastProperties] }, () => console.log(this.state.list));
  }

  checkItems = (value) => {
    let i = false;
    while (i === false) {
      switch (value) {
        case 'Deals':
          if (this.state.allCampaigns?.length === 0)
            value = "New Products"
          else i = true
          break;
        case 'New Products':
          if (this.state.allNewItems?.length === 0)
            value = "Favorites"
          else i = true
          break;
        case 'Favorites':
          if (this.state.allFavorites?.length === 0)
            value = "Your Choice"
          else i = true
          break;
        case 'Your Choice':
          if (this.state.allSold?.length === 0)
            value = "Discover"
          else i = true
          break;
        case 'Discover':
          if (this.state.notSold?.length === 0)
            value = "Deals"
          else i = true
          break;
        default:
          break;
      }
    }

    return value
  }

  componentDidMount() {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach((event) => {
      window.addEventListener(event, this.resetIdleTimer);
    });

    this.startIdleTimer();

    if (sessionStorage.getItem("items")) {
      this.onLoadSavedSlip()
        .then(() => {
          this.setState({
            productWebSubCategory: this.checkItems(this.state.productWebSubCategory)
          });
        })
        .catch((error) => {
          // Handle the error if the slip is not loaded

          console.error(error);
        });
    }

    if (this.state.token === null)
      this.onLogoutDeleteItemsAndCategories()

    if (!this.state.categories
      && !sessionStorage.getItem('allCategories')
      && sessionStorage.getItem('token'))
      fetchDataFromAPI(1306) //service for categories
        .then(json => {
          this.onGetCategories()
        })

    if (sessionStorage.getItem('allCategories')) {
      this.onGetCategories()
    }

    if (!sessionStorage.getItem('items') && sessionStorage.getItem('token'))
      fetchDataFromAPI(2015) //service for GetBasket AND! service for Items.Get.Customer.Catalog
        .then(json => {
          this.categorizeItems(json?.slipLines)
        }).then(() => this.setState({
          productWebSubCategory: this.checkItems(this.state.productWebSubCategory)
        }, () => console.log("hier"))


        )

  }

  onLogoutDeleteItemsAndCategories = () => {
    this.setState({
      items: null,
      cartItems: null,
      allCategories: null,
      categories: null,
      productWebSubCategory: "Deals"
    })
  }

  onGetCategories = () => {
    const cat = JSON.parse(sessionStorage.getItem('allCategories'));
    this.setState({
      categories: [...new Set(cat?.map(item =>
        item.itemCategoryName))],
      allCategories: cat,
      isLoaded: true
    }
    )
  }

  onGetItems = async () => {
    try {
      await this.onLoadSavedSlip();
      const productWebSubCategory = this.checkItems(this.state.productWebSubCategory);
      this.setState({ productWebSubCategory });
    } catch (error) {
      console.error(error);
    }
  };

  onLoadSavedSlip = () => {
    return new Promise((resolve, reject) => {
      const newState = sessionStorage.getItem('items');

      if (newState) {
        const parsedState = JSON.parse(newState);
        this.categorizeItems(parsedState)
          .then(() => {
            resolve(); // Resolve the Promise when the slip is loaded and categorization is done
          })
          .catch((error) => {
            reject(error); // Reject the Promise if an error occurs during categorization
          });
      } else {
        reject('No saved slip found'); // Reject the Promise if no slip is found
      }
    });
  };


  onWait = () => {
    this.setState({
      items: null,
      cartItems: null
    })
  }

  executeTask = async (obj) => {
    const json = await useFetchCampaignPrice(obj)  //service for GetCampaignPrice)
    if (json?.resCode === 200)
      obj = {
        ...obj, itemAmount: 0,
        itemCampaignPrice: json.dataSet ? json.dataSet[0]?.CampaignPrice : 0,
        ErpDiscRate: json.dataSet ? 0 : parseInt(sessionStorage.getItem("discRate")),
      }
    return obj
  }

  executeAllTasks = async () => {
    return await Promise.all(this.state.items?.map(obj =>
      obj.itemAmount > 0
        ? obj.itemCampaign
          ? this.executeTask(obj)
          : obj = { ...obj, itemAmount: 0 }
        : obj))
  }

  onSlipDeleteAllLines = async () => {
    this.executeAllTasks().then(newState => {
      sessionStorage.setItem('items', JSON.stringify(newState));
      this.categorizeItems(newState)
    })
  }

  categorizeItems = (newState) => {
    return new Promise((resolve, reject) => {
      const updateState = createUpdateState(newState);
      this.setState(updateState, () => {
        resolve(); // Resolve the Promise after the state has been updated
      });
    });
  };


  onAddAllFavorites = (item) => {

    item.itemFavorite = 1;
    const data = useSendDataToAPI(1310, item, item.itemFavorite)//service for Favorites
    sessionStorage.setItem('items', JSON.stringify(this.state.items))

    this.setState(previousState => ({ allFavorites: [...previousState.allFavorites, item] }));
    this.showToast('Favorite');
  }

  onRemoveAllFavorites = (item) => {
    item.itemFavorite = 0;
    sessionStorage.setItem('items', JSON.stringify(this.state.items))

    useSendDataToAPI(1310, item, item.itemFavorite) //service for Favorites
      .then(json => {
        this.setState({
          data: json
        });
      })

    this.setState(prevState =>
    ({
      allFavorites: this.state.allFavorites
        .filter((x) =>
          x.itemCode !== item.itemCode)
    })
    );
  }

  onAdd = async (item) => {
    this.setState((prevState) => ({ linearLoader: true }));
    this.setState((prevState) => ({ clickControl: true }));
    const exist = this.state.cartItems?.find(x => x.itemCode === item.itemCode);
    const existItem = this.state.items?.find(x => x.itemCode === item.itemCode);

    this.setState((prevState) => ({ clickedItemCode: item.itemCode }));

    updateItemAmountRequest(item, item.itemAmount ? item.itemAmount + 1 : 1)
      .then(async (json) => {
        this.setState((prevState) => ({ linearLoader: false }));
        this.setState((prevState) => ({ clickControl: false }));
        this.setState((prevState) => ({ clickedItemCode: "empty" }));
        if (json.resCode === 200) {

          if (json && json.dataSet && json.dataSet[0] && json.dataSet[0].erpItemAmount) {
            item.itemAmount = json.dataSet[0]?.erpItemAmount;
          } else {
            item.itemAmount = existItem.itemAmount + 1;
          }

          if (json && json.dataSet && json.dataSet[0] && json.dataSet[0].erpItemPrice) {
            item.erpItemPrice = json.dataSet[0]?.erpItemPrice;
          }


          this.setState(this.state.items?.map(x =>
            x.itemCode === item.itemCode
              ? (x.itemAmount = item.itemAmount)
              : x)
            , () => {

              item.itemCampaignPrice = json.dataSet[0]?.CampaignPrice;
              item.ErpDiscRate = json.dataSet[0]?.ErpDiscRate;

              this.setState({
                data: json
              })

              this.setState({

                allNewItems: this.state.items?.map(item =>
                  item.itemNew > 0 ? item : null
                ).filter((x) => x !== null),

                allCampaigns: this.state.items?.map(item =>
                  item.itemCampaign > 0 ? item : null
                ).filter((x) => x !== null),

                allSold: this.state.items?.map(item =>
                  item.itemSold > 0 ? item : null
                ).filter((x) => x !== null),

                notSold: this.state.items?.map(item =>
                  item.itemSold === 0 ? item : null
                ).filter((x) => x !== null),
              })
              sessionStorage.setItem('items', JSON.stringify(this.state.items))
            }
          );

          if (exist) {
            this.setState(this.state.cartItems?.map(x =>
              x.itemCode === item.itemCode
                ? (x.itemAmount = item.itemAmount)
                : x)
            )
          } else {
            item.itemAmount = 1;
            this.setState(previousState => ({ cartItems: [...previousState.cartItems, item] }));
          }
          //    toast.success(<Text tid={"Successfull"} />, { hideProgressBar: true });
        } else {
          toast.error(json.resMessage)
        }
      }).catch((err) => {
        toast.error(err)
        console.log(err);
      });

    // all items in the basket
    let counter = 0;
    this.state.cartItems?.forEach((cartItem) => {
      counter += cartItem.qty;
    })
  }

  onRemove = async (item) => {
    this.setState((prevState) => ({ linearLoader: true }));
    this.setState((prevState) => ({ clickControl: true }));

    const exist = this.state.cartItems?.find(x => x.itemCode === item.itemCode);
    const existItem = this.state.items?.find(x => x.itemCode === item.itemCode);

    this.setState((prevState) => ({ clickedItemCode: item.itemCode }));

    updateItemAmountRequest(item, item.itemAmount ? item.itemAmount - 1 : 0)
      .then(async (json) => {
        this.setState((prevState) => ({ linearLoader: false }));
        this.setState((prevState) => ({ clickControl: false }));
        if (json.resCode === 200) {

          if (json && json.dataSet && json.dataSet[0] && json.dataSet[0].erpItemAmount) {
            item.itemAmount = json.dataSet[0]?.erpItemAmount;
          } else {
            item.itemAmount = existItem.itemAmount - 1;
          }

          if (json && json.dataSet && json.dataSet[0] && json.dataSet[0].erpItemPrice) {
            item.erpItemPrice = json.dataSet[0]?.erpItemPrice;
          }

          item.itemCampaignPrice = json.dataSet[0]?.CampaignPrice;
          item.ErpDiscRate = json.dataSet[0]?.ErpDiscRate;

          sessionStorage.setItem("items", JSON.stringify(this.state.items))
          this.setState({
            data: json
          })

          this.setState(this.state.items?.map(x =>
            x.itemCode === item.itemCode
              ? (x.itemAmount = item.itemAmount)
              : x)
            , () => {

              this.setState({

                allNewItems: this.state.items?.map(item =>
                  item.itemNew > 0 ? item : null
                ).filter((x) => x !== null),

                allCampaigns: this.state.items?.map(item =>
                  item.itemCampaign > 0 ? item : null
                ).filter((x) => x !== null),

                allSold: this.state.items?.map(item =>
                  item.itemSold > 0 ? item : null
                ).filter((x) => x !== null),

                notSold: this.state.items?.map(item =>
                  item.itemSold === 0 ? item : null
                ).filter((x) => x !== null),
              })
              sessionStorage.setItem('items', JSON.stringify(this.state.items))
            }
          );
          //if(this.state.cartItems.length === 0) this.setState({ detailedBasket: false })
          if (item.itemAmount === 0) {
            this.setState(prevState => ({ cartItems: prevState.cartItems.filter((x) => x.itemCode !== item.itemCode) })
              , () => {
                if (this.state.cartItems.length === 0) this.setState({ detailedBasket: false });
              }
            );
            item.itemAmount = null;

          } else {
            this.setState(this.state.cartItems?.map(x => x.itemCode === item.itemCode ? x.itemAmount = item.itemAmount : x
            ));
          }
          //      toast.success(<Text tid={"Successfull"}></Text>, { hideProgressBar: true });
        } else {
          toast.error(json.resMessage);
        }
        this.setState((prevState) => ({ clickControl: false }));
        this.setState((prevState) => ({ clickedItemCode: "empty" }));
      }).catch((err) => {
        toast.error(err);
      });
  }

  handleViewCategorySidebar = () => {
    this.setState(({ sidebarOpen }) => ({
      sidebarOpen: !sidebarOpen
    }));
  };

  switchToNext(item, value) {
    if (item !== "PickedProducts" && item !== "Home") {
      return value;
    }

    let i = false;

    while (i === false) {
      if (!value) value = 'Deals'
      switch (value) {
        case 'Deals':
          if (this.state.allCampaigns.length === 0)
            value = "New Products"
          else i = true
          break;
        case 'New Products':

          if (this.state.allNewItems.length === 0)
            value = "Favorites"
          else i = true
          break;
        case 'Favorites':

          if (this.state.allFavorites.length === 0)
            value = "Your Choice"
          else i = true
          break;
        case 'Your Choice':

          if (this.state.allSold.length === 0)
            value = "Discover"
          else i = true
          break;
        case 'Discover':

          if (this.state.notSold.length === 0)
            value = "Deals"
          else i = true
          break;
        default:
          value = "Deals"
          break;
      }
    }
    return value
  }

  WebCategory = (item, x) => {
    window.scrollTo(0, 0)
    this.setState({ filteredData: "" });
    if (item)
      this.setState({ productWebCategory: item });

    this.setState({
      productWebSubCategory: this.switchToNext(item, x)
    });


    if (x === null)
      window.scrollTo(0, 0)

    const elemToScrollTo = document.getElementById(x)
    if (elemToScrollTo) {
      elemToScrollTo.scrollIntoView()
    }
    return this.switchToNext(item, x)
  };

  setAppToken = (data) => {
    this.setState({ token: data });
  };

  setItems = (e, item) => {

    if (e) {
      this.setState(this.state.items?.map(x =>
        x.itemCode === item.itemCode
          ? x.itemAmount = e
          : x)
        , () => {
          this.setState({

            allNewItems: this.state.items?.map(item =>
              item.itemNew > 0 ? item : null
            ).filter((x) => x !== null),

            allCampaigns: this.state.items?.map(item =>
              item.itemCampaign > 0 ? item : null
            ).filter((x) => x !== null),

            allSold: this.state.items?.map(item =>
              item.itemSold > 0 ? item : null
            ).filter((x) => x !== null),

            notSold: this.state.items?.map(item =>
              item.itemSold === 0 ? item : null
            ).filter((x) => x !== null),
          })
          sessionStorage.setItem('items', JSON.stringify(this.state.items))
        }
      );

      const exist = this.state.cartItems
        .find(x => x.itemCode === item.itemCode);
      if (exist) {
        this.setState(this.state.cartItems?.map(x => x.itemCode === item.itemCode
          ? x.itemAmount = e
          : x
        ));
      } else {
        item.itemAmount = e;
        this.setState(previousState =>
          ({ cartItems: [...previousState.cartItems, item] }));
      }
      let counter = 0;
      this.state.cartItems.forEach((cartItem) => {
        counter += cartItem.qty;
      })
    }
    else {
      this.setState(this.state.items?.map(x =>
        x.itemCode === item.itemCode
          ? x.itemAmount = e
          : x)
        , () => {

          this.setState({

            allNewItems: this.state.items?.map(item =>
              item.itemNew > 0 ? item : null
            ).filter((x) => x !== null),

            allCampaigns: this.state.items?.map(item =>
              item.itemCampaign > 0 ? item : null
            ).filter((x) => x !== null),

            allSold: this.state.items?.map(item =>
              item.itemSold > 0 ? item : null
            ).filter((x) => x !== null),

            notSold: this.state.items?.map(item =>
              item.itemSold === 0 ? item : null
            ).filter((x) => x !== null),
          })
          sessionStorage.setItem('items', JSON.stringify(this.state.items))
        }
      );

      const exist = this.state.cartItems
        .find((x) =>
          x.itemCode === item.itemCode
        );
      if (exist) {
        this.setState(prevState => ({
          cartItems: this.state.cartItems
            .filter((x) =>
              x.itemCode !== item.itemCode
            )
        })
          , () => {
            if (this.state.cartItems.length === 0) this.setState({ detailedBasket: false });

          }


        );
        item.itemAmount = null;
      }
    }
  }

  handleChangeCount = (event, item) => {
    const e = event.target.valueAsNumber;

    updateItemAmountRequest(item, e ? e : 0).then(json => {
        if (json.resCode === 200) {
          item.itemCampaignPrice = json.dataSet[0]?.CampaignPrice;
          item.ErpDiscRate = json.dataSet[0]?.ErpDiscRate;
          this.setItems(e, item)
          sessionStorage.setItem("items", JSON.stringify(this.state.items))
          this.setState({
            data: json
          })
        } else {
          toast.error(json.resMessage);
        }
      }).catch((err) => {
        toast.error(err);
        console.log(err);
      });
  }

  search = (value) => {
    if (value) {
      // Girilen değeri kelimelere ayır
      const keywords = value.toLowerCase().split(" ");

      let searchResults = this.state.items.filter(item => {
        // `item` içindeki tüm string değerleri birleştir
        const itemString = Object.values(item)
          .filter(val => typeof val === "string") // Sadece string değerleri al
          .join(" ")
          .toLowerCase();

        // Her bir kelimenin `itemString` içinde geçip geçmediğini kontrol et
        return keywords.every(keyword => itemString.includes(keyword));
      });

      this.setState({
        filteredData: searchResults,
        productWebCategory: "SearchResults",
        productWebSubCategory: value
      });
    } else {
      // Eğer arama kutusu boşsa, tüm veriyi geri yükle
      this.setState({ filteredData: this.state.items });
    }
  };


  render() {

    const fetchDefaultPayment = async () => {
      if (sessionStorage.getItem('token') === null || sessionStorage.getItem('token') === undefined || sessionStorage.getItem('token') === "" || sessionStorage.getItem('paymentType') !== undefined || sessionStorage.getItem('paymentType') !== "") {
        const key = secureKeyGet(sessionStorage.getItem('stripeApiKey'));
        const stripe = await loadStripe(key);
        if (this.state.stripePromise === null) {
          this.setState({ stripePromise: stripe });
        } else {

        }

        return;

      } else {
        try {

          if (sessionStorage.getItem("token")) {
            const res = await getSettingJSONRequest(101, 6);
            const list = JSON.parse(res.dataSet[0]["settingJson"]);

            const payment = list.find(p => p.isDefault === 1);

            if (payment) {
              //    setDefaultPayment(payment.paymentType);
              sessionStorage.setItem("paymentType", payment.paymentType);
              //  paymentType = payment.paymentType;
              if (payment.paymentType === "stripe") {
                const key = secureKeyGet(payment.apiKey);
                const stripe = await loadStripe(key);
                this.setState({ stripePromise: stripe });
              }
            }
          }

        } catch (error) {
          console.error("Ödeme ayarları alınırken hata:", error);
        }
      }

    };

    fetchDefaultPayment();

    const handlePaymentSuccess = () => {
      toast.success(<Text tid={"PaymentSuccess"} />)
      this.setState({ loadingOverlay: true });
      const url = NEWURL;

      const requestOptions = {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: JSON.stringify({
          "serviceId": 4003, //Slip Send //4003
          "token": sessionStorage.getItem('token'),
          "vendorId": NEWVENDORID,
          "slipRef": sessionStorage.getItem('slipRef'),
          "erpGenExpl1": sessionStorage.getItem('Expl1') ?? "",
          "erpGenExpl2": sessionStorage.getItem('Expl2') ?? "",
          "paymentTrackingId": sessionStorage.getItem('paymentTrackingId') ?? "",
          "paymentMethod": sessionStorage.getItem('paymentType') ?? ""
        })
      };

      const fetchData = async () => {
        try {
          const response = await fetch(url, requestOptions);
          const json = await response.json();

          if (json.resCode == 200) {
            sessionStorage.setItem('slipRef', json.dataSet[0]?.slipRef);
            sessionStorage.removeItem('Expl1');
            sessionStorage.removeItem('Expl2');
            sessionStorage.removeItem('paymentTrackingId');

            this.onSlipDeleteAllLines();
            toast.success(<><Text tid={"OrderSuccess"} /> {json.dataSet[0]["erpFicheNo"]}</>, {
              hideProgressBar: true,
              autoClose: false,
            });
          } else {
            toast.error(json.resMessage);
          }
          this.setState({ loadingOverlay: false });
        } catch (error) {
          console.error("Error fetching data:", error);
          this.setState({ loadingOverlay: false });
          toast.error(error);
        }
      };
      fetchData();
    };

    const { stripePromise } = this.state;

    return (
      <Router>
        <Routes>
          <Route path="/" element={<LanguageProvider>
            <div
              className="h-screen w-screen overflow-x-hidden"
            >

              <Helmet>
                <title>{CONFIG.COMPANYNAME} - {CONFIG.PROJECTNAME == "akar" ? "Shop" : "WebShop"}</title>
                <meta name="description" content={`${CONFIG.COMPANYNAME}`} />
              </Helmet>

              {/* Header */}
              <header
                className="sticky top-0 z-40 h-14 flex w-full "
              >
                {!sessionStorage.getItem("token") ?
                  <MenuLogin
                    ShowImpressum={(value) => this.ShowImpressum(value)}
                    ShowDatenschutz={(value) => this.ShowDatenschutz(value)}
                    ShowAGB={(value) => this.ShowAGB(value)}
                    ShowContact={(value) => this.ShowContact(value)}
                    ShowAboutUs={(value) => this.ShowAboutUs(value)}
                    WebCategory={this.WebCategory}
                    onClick={() => this.handleViewCategorySidebar()}
                    setAppToken={this.setAppToken}
                    search={this.search}
                    onLoadSavedSlip={() => this.onLoadSavedSlip()}
                    onWait={this.onWait}
                    onGetItems={() => this.onGetItems()}
                    onGetCategories={() => this.onGetCategories()}
                    onLogoutDeleteItemsAndCategories={() => this.onLogoutDeleteItemsAndCategories()}
                  /> :
                  <MenuHome
                    ShowImpressum={(value) => this.ShowImpressum(value)}
                    ShowDatenschutz={(value) => this.ShowDatenschutz(value)}
                    ShowAGB={(value) => this.ShowAGB(value)}
                    ShowContact={(value) => this.ShowContact(value)}
                    ShowAboutUs={(value) => this.ShowAboutUs(value)}
                    cartCount={this.state.cartItems ? this.state.cartItems.length : 0}
                    isCategoryOpen={this.state.isCategoryOpen}
                    toggleMenu={() => this.toggleMenu()}
                    toggleCart={() => this.toggleCart()}
                    WebCategory={this.WebCategory}
                    onClick={() => this.handleViewCategorySidebar()}
                    setAppToken={this.setAppToken}
                    search={this.search}
                    onLoadSavedSlip={() => this.onLoadSavedSlip()}
                    onWait={this.onWait}
                    onGetItems={() => this.onGetItems()}
                    onGetCategories={() => this.onGetCategories()}
                    onLogoutDeleteItemsAndCategories={() => this.onLogoutDeleteItemsAndCategories()}
                  />}
              </header >

              {/* Main */}
              {
                !sessionStorage.getItem("token")
                  ? <main className=" relative px-4 py-2 flex  w-full h-[calc(100%-5rem)] overflow-hidden ">
                    <iframe className="responsive-iframe " src="pages/index.html" title="LandingPage"></iframe>
                  </main>
                  : <main
                    className="relative px-2 flex w-full md:h-[calc(100%-5rem)]"
                  >
                    <div
                      className="relative flex flex-col h-full w-full "
                    >
                      <div
                        className={`${this.state.productWebCategory !== "Home"
                          ? "h-full w-full "
                          : !NEWBRANDS
                            ? "h-full w-full"
                            : ""} flex flex-row w-full`
                        }
                      >
                        <CategoryList

                          productWebCategory={this.state.productWebCategory}
                          WebCategory={this.WebCategory}
                          allCategories={this.state.allCategories}
                          itemCategoryName={this.state.categories}
                          existCampaigns={this.state.allCampaigns?.length}
                          existNewItems={this.state.allNewItems?.length}
                          existFavorites={this.state.allFavorites?.length}
                          existSoldItems={this.state.allSold?.length}
                          existNotSoldItems={this.state.notSold?.length}
                          isCategoryOpen={this.state.isCategoryOpen}
                          isCartOpen={this.state.isCartOpen}
                          toggleMenu={() => this.toggleMenu()}
                          toggleCart={() => this.toggleCart()}
                          productWebSubCategory={this.state.productWebSubCategory}
                        />

                        <Content
                          isCategoryOpen={this.state.isCategoryOpen}
                          isCartOpen={this.state.isCartOpen}
                          items={this.state.items}
                          allFavorites={this.state.allFavorites}
                          allCampaigns={this.state.allCampaigns}
                          allNewItems={this.state.allNewItems}
                          allSold={this.state.allSold}
                          itemSubCategoryName={this.state.itemSubCategoryName}
                          notSold={this.state.notSold}
                          onRemove={this.onRemove}
                          onAdd={this.onAdd}
                          clickControl={this.state.clickControl}
                          clickedItemCode={this.state.clickedItemCode}
                          handleChangeCount={this.handleChangeCount}
                          productWebCategory={this.state.productWebCategory}
                          productWebSubCategory={this.state.productWebSubCategory}
                          itemCategoryName={this.state.itemCategoryName}
                          allCategories={this.state.allCategories}
                          onAddAllFavorites={this.onAddAllFavorites}
                          onRemoveAllFavorites={this.onRemoveAllFavorites}
                          value={this.state.value}
                          filteredData={this.state.filteredData}

                          sortingKey={this.state.sortingKey}
                          ascending={this.state.ascending}
                          sortingFunc={this.sortingFunc}
                        />
                        <ConciseBasket
                          onAdd={this.onAdd}
                          onRemove={this.onRemove}
                          cartItems={this.state.cartItems}
                          onAddAllFavorites={this.onAddAllFavorites}
                          onRemoveAllFavorites={this.onRemoveAllFavorites}
                          onSlipDeleteAllLines={() => this.onSlipDeleteAllLines()}
                          ShowDetailedBasket={(value) => this.ShowDetailedBasket(value)}
                          isCartOpen={this.state.isCartOpen}
                          linearLoader={this.state.linearLoader}
                          toggleCart={() => this.toggleCart()}

                        />
                      </div>
                      {this.state.productWebCategory
                        && NEWBRANDS
                        && this.state.productWebCategory === "Home"
                        ?
                        <div
                          className="absolute flex flex-row h-24  inset-x-0 bottom-0"
                        >
                          <Brands />
                        </div>
                        : null
                      }
                    </div>
                  </main >
              }

              {/* Footer */}
              <footer
                className="fixed bottom-0 flex w-full h-7 items-center justify-center "
              >
                <AppFooter
                  ShowImpressum={(value) => this.ShowImpressum(value)}
                  ShowDatenschutz={(value) => this.ShowDatenschutz(value)}
                  ShowAGB={(value) => this.ShowAGB(value)}
                  ShowContact={(value) => this.ShowContact(value)}
                  ShowAboutUs={(value) => this.ShowAboutUs(value)}
                />
              </footer>

              {this.state.loadingOverlay ? <LoadingOverlay></LoadingOverlay> : null}

            </div>

            <Toast
              toastList={this.state.list}
              autoDelete={this.state.autoDelete}
              autoDeleteTime={this.state.autoDeleteTime}
            />
            <ShowImpressum impressum={this.state.impressum} ShowImpressum={(value) => this.ShowImpressum(value)} />
            <ShowDatenschutz datenschutz={this.state.datenschutz} ShowDatenschutz={(value) => this.ShowDatenschutz(value)} />
            <ShowAGB agb={this.state.agb} ShowAGB={(value) => this.ShowAGB(value)} />
            <ShowContact contact={this.state.contact} ShowContact={(value) => this.ShowContact(value)} />
            <ShowAboutUs aboutUs={this.state.aboutUs} ShowAboutUs={(value) => this.ShowAboutUs(value)} />
            <ShowDetailedBaskett
              ShowDatenschutz={(value) => this.ShowDatenschutz(value)}
              ShowAGB={(value) => this.ShowAGB(value)}
              showToast={(type) => this.showToast(type)}
              detailedBasket={this.state.detailedBasket}
              ShowDetailedBasket={(value) => this.ShowDetailedBasket(value)}
              onAddAllFavorites={this.onAddAllFavorites}
              onRemoveAllFavorites={this.onRemoveAllFavorites}
              cartItems={this.state.cartItems}
              //onClick={this.props.onClickIncrement}
              onAdd={(record) =>
                this.onAdd(record)
              }
              onRemove={(record) =>
                this.onRemove(record)
              }
              onSlipDeleteAllLines={() => this.onSlipDeleteAllLines()}

              toggleLoadingOverlay={(state) => this.toggleLoadingOverlay(state)}
              loadingOverlay={this.state.loadingOverlay}
              slipRef={sessionStorage.getItem('slipRef')}
            />


            <CookieConsent
              ShowImpressum={(value) => this.ShowImpressum(value)}
              ShowDatenschutz={(value) => this.ShowDatenschutz(value)} />

            <ToastContainer position="top-right" autoClose={3000} />

          </LanguageProvider>} />
          <Route
            path="/payment-success"
            element={<Elements stripe={stripePromise}>
              <PaymentSuccess onSuccess={handlePaymentSuccess} />
              <ToastContainer position="top-right" autoClose={3000} />
            </Elements>}
          />
          <Route
            path="/stripe-success"
            element={
              <StripeSuccess onSuccess={handlePaymentSuccess} />

            }
          />


          { /* Mobile app register page  */}
          <Route
            path="/register"
            element={
              <LanguageProvider>
                <RegisterModal showModal={true} platform={"mobileApp"} />
              </LanguageProvider>

            }
          />
        </Routes>
      </Router>


    );
  }
}